// extracted by mini-css-extract-plugin
export default {"uploader":"file-uploader-video_uploader__j7Rwo"};